import GroupPage from './GroupPage'
import Group from './Group'
import GroupDetails from './GroupDetails'
import SubscriberPermission from 'app/main/subscribersV4/components/SubscriberPermission'
import { AccessType } from 'app/auth/accessControlService'

export default {
  settings: {
    layout: {
      config: {
        navbar: {
          display: true,
        },
        toolbar: {
          display: true,
        },
        leftSidePanel: {
          display: true,
        },
      },
    },
  },
  routes: [
    {
      path: '/groups4',
      accesses: [AccessType.NOTIFICATION_VIEW_OWNED],
      component: GroupPage,
      routes: [
        {
          exact: true,
          path: '/groups4',
          component: Group,
        },
        {
          exact: true,
          path: '/groups4/permission-denied',
          component: SubscriberPermission,
        },
        {
          exact: true,
          path: '/groups4/:groupId',
          component: GroupDetails,
        },
      ],
    },
  ],
}
